import type { Language } from '@/i18n/types';
import { isValidUuid } from '../utils/uuid';

export interface PageSeo {
  title: string;
  description: string;
  h1: string;
}

export type RouteSeo = Record<Language, PageSeo>;

export const ROUTE_SEO: Readonly<Record<string, RouteSeo>> = {
  '/': {
    ru: {
      title: 'SHOT — открывай кейсы CS2 и получай скины',
      description:
        'Открывай кейсы CS2 на SHOT, играй в Case Battles и собирай скины. Предмет можно продать за баланс или вывести в Steam, если вывод для него доступен.',
      h1: 'Кейсы CS2 и скины на SHOT',
    },
    en: {
      title: 'SHOT — open CS2 cases and get skins',
      description:
        'Open CS2 cases on SHOT, play Case Battles and collect skins. Sell an item for balance or withdraw it to Steam when withdrawal is available for it.',
      h1: 'CS2 cases and skins on SHOT',
    },
    uz: {
      title: 'SHOT — CS2 keyslarini och va skinlar ol',
      description:
        'SHOTʼda CS2 keyslarini och, Keys Janglarda oʻyna va skinlar yigʻ. Predmetni balansga sotish yoki imkon boʻlsa oʻz Steam akkauntingga chiqarish mumkin.',
      h1: 'SHOTʼda CS2 keyslari va skinlar',
    },
    fa: {
      title: 'SHOT — کیس‌های CS2 را باز کن و اسکین بگیر',
      description:
        'در SHOT کیس‌های CS2 را باز کن، در نبرد کیس بازی کن و اسکین جمع کن. آیتم را می‌توانی با موجودی بفروشی یا اگر برداشتش ممکن بود به Steam برداشت کنی.',
      h1: 'کیس‌ها و اسکین‌های CS2 در SHOT',
    },
    pt: {
      title: 'SHOT — abra caixas de CS2 e ganhe skins',
      description:
        'Abra caixas de CS2 no SHOT, jogue Batalhas de caixas e junte skins. Venda o item por saldo ou retire-o para a Steam quando a retirada estiver disponível.',
      h1: 'Caixas e skins de CS2 no SHOT',
    },
    tr: {
      title: 'SHOT — CS2 kasalarını aç, skin kazan',
      description:
        "SHOT'ta CS2 kasalarını aç, kasa savaşlarına katıl ve skin topla. Eşyayı bakiye karşılığında satabilir ya da mümkünse Steam hesabına çekebilirsin.",
      h1: "SHOT'ta CS2 kasaları ve skinler",
    },
  },
  '/cases': {
    ru: {
      title: 'Кейсы CS2 — открыть онлайн на SHOT',
      description:
        'Каталог кейсов SHOT: смотри, какие скины CS2 лежат в каждом кейсе и с каким шансом они выпадают. Выбирай кейс по цене и открывай онлайн.',
      h1: 'Кейсы CS2',
    },
    en: {
      title: 'CS2 cases — open online on SHOT',
      description:
        'The SHOT case catalog: see which CS2 skins each case holds and the drop chance of every one. Pick a case by price and open it online.',
      h1: 'CS2 cases',
    },
    uz: {
      title: 'CS2 keyslari — SHOTʼda onlayn och',
      description:
        'SHOT keyslar katalogi: har bir keysda qaysi CS2 skinlari borligini va ularning tushish ehtimolini koʻr. Keysni narxiga qarab tanla va onlayn och.',
      h1: 'CS2 keyslari',
    },
    fa: {
      title: 'کیس‌های CS2 — باز کردن آنلاین در SHOT',
      description:
        'کاتالوگ کیس‌های SHOT: ببین در هر کیس چه اسکین‌های CS2 هست و شانس دراپ هرکدام چقدر است. کیس را بر اساس قیمت انتخاب کن و آنلاین باز کن.',
      h1: 'کیس‌های CS2',
    },
    pt: {
      title: 'Caixas de CS2 — abra online no SHOT',
      description:
        'Catálogo de caixas do SHOT: veja quais skins de CS2 cada caixa tem e a chance de cada uma cair. Escolha a caixa pelo preço e abra online.',
      h1: 'Caixas de CS2',
    },
    tr: {
      title: "CS2 kasaları — SHOT'ta online aç",
      description:
        'SHOT kasa kataloğu: her kasada hangi CS2 skinlerinin olduğunu ve her birinin düşme şansını gör. Kasayı fiyatına göre seç ve online aç.',
      h1: 'CS2 kasaları',
    },
  },
  '/case-battles': {
    ru: {
      title: 'Case Battles — кейс-баттлы CS2 на SHOT',
      description:
        'Открывай кейсы одновременно с другими игроками: выбирай кейсы и режим, играй один на один или командой. Смотри открытые баттлы и заходи в любой.',
      h1: 'Кейс-баттлы CS2',
    },
    en: {
      title: 'Case Battles — CS2 case battles on SHOT',
      description:
        'Open cases at the same time as other players: pick the cases and the mode, play one on one or as a team. Browse open battles and join any of them.',
      h1: 'CS2 case battles',
    },
    uz: {
      title: 'Keys Janglar — SHOTʼda CS2 keys janglari',
      description:
        'Keyslarni boshqa oʻyinchilar bilan bir vaqtda och: keyslar va rejimni tanla, yakkama-yakka yoki jamoa boʻlib oʻyna. Ochiq janglarni koʻr va istalganiga qoʻshil.',
      h1: 'CS2 keys janglari',
    },
    fa: {
      title: 'نبرد کیس — نبردهای کیس CS2 در SHOT',
      description:
        'کیس‌ها را هم‌زمان با بازیکنان دیگر باز کن: کیس‌ها و حالت بازی را انتخاب کن و تک‌به‌تک یا تیمی بازی کن. نبردهای باز را ببین و به هرکدام بپیوند.',
      h1: 'نبردهای کیس CS2',
    },
    pt: {
      title: 'Batalhas de caixas de CS2 no SHOT',
      description:
        'Abra caixas ao mesmo tempo que outros jogadores: escolha as caixas e o modo, jogue um contra um ou em equipe. Veja as batalhas abertas e entre em qualquer uma.',
      h1: 'Batalhas de caixas de CS2',
    },
    tr: {
      title: "SHOT'ta CS2 kasa savaşları",
      description:
        'Kasaları diğer oyuncularla aynı anda aç: kasaları ve modu seç, bire bir ya da takım olarak oyna. Açık savaşlara göz at ve istediğine katıl.',
      h1: 'CS2 kasa savaşları',
    },
  },
  '/case-battles/[battleId]': {
    ru: {
      title: 'Кейс-баттл CS2 — SHOT',
      description:
        'Кейс-баттл на SHOT: какие кейсы открыли участники, что выпало каждому и чем закончился баттл. Создай свой баттл или зайди в открытый.',
      h1: 'Кейс-баттл',
    },
    en: {
      title: 'CS2 case battle — SHOT',
      description:
        'A case battle on SHOT: which cases the players opened, what each of them got and how the battle ended. Create your own battle or join an open one.',
      h1: 'Case battle',
    },
    uz: {
      title: 'CS2 keys jangi — SHOT',
      description:
        'SHOTʼdagi keys jangi: ishtirokchilar qaysi keyslarni ochgani, har biriga nima tushgani va jang qanday tugagani. Oʻz jangingni yarat yoki ochiq jangga qoʻshil.',
      h1: 'Keys jangi',
    },
    fa: {
      title: 'نبرد کیس CS2 — SHOT',
      description:
        'یک نبرد کیس در SHOT: بازیکنان چه کیس‌هایی باز کردند، به هرکدام چه رسید و نبرد چطور تمام شد. نبرد خودت را بساز یا به یک نبرد باز بپیوند.',
      h1: 'نبرد کیس',
    },
    pt: {
      title: 'Batalha de caixas de CS2 — SHOT',
      description:
        'Uma batalha de caixas no SHOT: quais caixas os jogadores abriram, o que cada um recebeu e como a batalha terminou. Crie a sua ou entre em uma aberta.',
      h1: 'Batalha de caixas',
    },
    tr: {
      title: 'CS2 kasa savaşı — SHOT',
      description:
        "SHOT'ta bir kasa savaşı: oyuncuların hangi kasaları açtığı, her birine ne düştüğü ve savaşın nasıl bittiği. Kendi savaşını kur ya da açık bir savaşa katıl.",
      h1: 'Kasa savaşı',
    },
  },
  '/shop': {
    ru: {
      title: 'Магазин скинов CS2 — SHOT',
      description:
        'Покупай скины CS2 в магазине SHOT за баланс: ножи, перчатки, винтовки, пистолеты, стикеры, агенты и брелоки. Подбирай по цене, редкости и износу.',
      h1: 'Магазин скинов CS2',
    },
    en: {
      title: 'CS2 skin shop — SHOT',
      description:
        'Buy CS2 skins in the SHOT shop with your balance: knives, gloves, rifles, pistols, stickers, agents and keychains. Filter by price, rarity and wear.',
      h1: 'CS2 skin shop',
    },
    uz: {
      title: 'CS2 skinlari doʻkoni — SHOT',
      description:
        'SHOT doʻkonida CS2 skinlarini balansga sotib ol: pichoqlar, qoʻlqoplar, miltiqlar, toʻpponchalar, stikerlar va agentlar. Narx, kamyoblik va holat boʻyicha tanla.',
      h1: 'CS2 skinlari doʻkoni',
    },
    fa: {
      title: 'فروشگاه اسکین CS2 — SHOT',
      description:
        'اسکین‌های CS2 را با موجودی از فروشگاه SHOT بخر: چاقو، دستکش، رایفل، پیستول، استیکر، ایجنت و آویز. بر اساس قیمت، کمیابی و فرسودگی انتخاب کن.',
      h1: 'فروشگاه اسکین CS2',
    },
    pt: {
      title: 'Loja de skins de CS2 — SHOT',
      description:
        'Compre skins de CS2 na loja do SHOT com o seu saldo: facas, luvas, rifles, pistolas, adesivos, agentes e chaveiros. Filtre por preço, raridade e desgaste.',
      h1: 'Loja de skins de CS2',
    },
    tr: {
      title: 'CS2 skin mağazası — SHOT',
      description:
        "SHOT mağazasından bakiyenle CS2 skinleri al: bıçaklar, eldivenler, tüfekler, tabancalar, çıkartmalar, ajanlar ve anahtarlıklar. Fiyata, nadirliğe ve aşınmaya göre seç.",
      h1: 'CS2 skin mağazası',
    },
  },
  '/games': {
    ru: {
      title: 'Игры SHOT: Rush Mid, русская рулетка и Upgrade',
      description:
        'Все режимы SHOT в одном месте: Rush Mid, русская рулетка, Case Battles, контракты, Upgrade и магазин скинов. Выбирай, во что играть сегодня.',
      h1: 'Игры и режимы SHOT',
    },
    en: {
      title: 'SHOT games: Rush Mid, Russian Roulette and Upgrade',
      description:
        'Every SHOT mode in one place: Rush Mid, Russian Roulette, Case Battles, Contracts, Upgrade and the skin shop. Pick what you want to play today.',
      h1: 'SHOT games and modes',
    },
    uz: {
      title: 'SHOT oʻyinlari: Rush Mid, Rus ruletkasi va Upgrade',
      description:
        'SHOTʼning barcha rejimlari bir joyda: Rush Mid, Rus ruletkasi, Keys Janglar, Kontraktlar, Upgrade va skinlar doʻkoni. Bugun nima oʻynashni tanla.',
      h1: 'SHOT oʻyinlari va rejimlari',
    },
    fa: {
      title: 'بازی‌های SHOT: Rush Mid، رولت روسی و ارتقا',
      description:
        'همه حالت‌های SHOT در یک جا: Rush Mid، رولت روسی، نبرد کیس، قراردادها، ارتقا و فروشگاه اسکین. انتخاب کن امروز چه بازی کنی.',
      h1: 'بازی‌ها و حالت‌های SHOT',
    },
    pt: {
      title: 'Jogos do SHOT: Rush Mid, Roleta russa e Upgrade',
      description:
        'Todos os modos do SHOT em um só lugar: Rush Mid, Roleta russa, Batalhas de caixas, Contratos, Upgrade e a loja de skins. Escolha o que jogar hoje.',
      h1: 'Jogos e modos do SHOT',
    },
    tr: {
      title: 'SHOT oyunları: Rush Mid, Rus ruleti ve Upgrade',
      description:
        "SHOT'un tüm modları tek yerde: Rush Mid, Rus ruleti, Kasa savaşları, Kontratlar, Upgrade ve skin mağazası. Bugün ne oynayacağını seç.",
      h1: 'SHOT oyunları ve modları',
    },
  },
  '/draws': {
    ru: {
      title: 'Победители розыгрышей SHOT',
      description:
        'Последние победители розыгрышей SHOT: кто получил награду, какой предмет ему достался и когда. Участвуй в розыгрышах и получай XP за участие.',
      h1: 'Победители розыгрышей',
    },
    en: {
      title: 'SHOT draw winners',
      description:
        'The latest SHOT draw winners: who got a reward, which item they received and when. Take part in the draws and earn XP just for joining in.',
      h1: 'Draw winners',
    },
    uz: {
      title: 'SHOT qura gʻoliblari',
      description:
        'SHOT quralarining soʻnggi gʻoliblari: kim mukofot olgani, unga qaysi predmet tushgani va qachon. Qurada qatnash va ishtirok uchun XP ol.',
      h1: 'Qura gʻoliblari',
    },
    fa: {
      title: 'برندگان قرعه‌کشی‌های SHOT',
      description:
        'آخرین برندگان قرعه‌کشی‌های SHOT: چه کسی جایزه گرفت، چه آیتمی به او رسید و کی. در قرعه‌کشی‌ها شرکت کن و برای شرکت XP بگیر.',
      h1: 'برندگان قرعه‌کشی',
    },
    pt: {
      title: 'Vencedores dos sorteios do SHOT',
      description:
        'Os últimos vencedores dos sorteios do SHOT: quem levou a recompensa, qual item recebeu e quando. Participe dos sorteios e ganhe XP só por participar.',
      h1: 'Vencedores dos sorteios',
    },
    tr: {
      title: 'SHOT çekiliş kazananları',
      description:
        'SHOT çekilişlerinin son kazananları: ödülü kim aldı, hangi eşyayı kazandı ve ne zaman. Çekilişlere katıl, sadece katıldığın için XP kazan.',
      h1: 'Çekiliş kazananları',
    },
  },
  '/rains': {
    ru: {
      title: 'Прошедшие раздачи SHOT',
      description:
        'История раздач SHOT: какие предметы разыгрывались, сколько игроков успело зайти и кто их забрал. Окно раздачи короткое — следи, чтобы не пропустить следующую.',
      h1: 'Прошедшие раздачи',
    },
    en: {
      title: 'Past SHOT giveaways',
      description:
        'The history of SHOT giveaways: which items were up for grabs, how many players made it in and who took them. The window is short, so watch for the next one.',
      h1: 'Past giveaways',
    },
    uz: {
      title: 'SHOTʼning oʻtgan ulashishlari',
      description:
        'SHOT ulashishlari tarixi: qaysi predmetlar ulashilgani, nechta oʻyinchi kirishga ulgurgani va ularni kim olgani. Ulashish oynasi qisqa — keyingisini oʻtkazib yuborma.',
      h1: 'Oʻtgan ulashishlar',
    },
    fa: {
      title: 'پخش‌های گذشته SHOT',
      description:
        'تاریخچه پخش‌های SHOT: چه آیتم‌هایی پخش شد، چند بازیکن به موقع وارد شدند و چه کسی آن‌ها را برد. فرصت ورود کوتاه است، پخش بعدی را از دست نده.',
      h1: 'پخش‌های گذشته',
    },
    pt: {
      title: 'Sorteios anteriores do SHOT',
      description:
        'Histórico dos sorteios relâmpago do SHOT: quais itens foram distribuídos, quantos jogadores entraram a tempo e quem os levou. A janela é curta, fique atento ao próximo.',
      h1: 'Sorteios anteriores',
    },
    tr: {
      title: 'SHOT geçmiş çekilişleri',
      description:
        "SHOT'taki anlık çekilişlerin geçmişi: hangi eşyalar dağıtıldı, kaç oyuncu zamanında girdi ve onları kim aldı. Giriş süresi kısa, bir sonrakini kaçırma.",
      h1: 'Geçmiş çekilişler',
    },
  },
  '/achievements': {
    ru: {
      title: 'Трофеи SHOT — задания и награды',
      description:
        'Все трофеи SHOT: за кейсы, Upgrade, контракты, Rush Mid, Case Battles и активность. Смотри условия получения, свой прогресс и награду за каждый трофей.',
      h1: 'Трофеи SHOT',
    },
    en: {
      title: 'SHOT trophies — challenges and rewards',
      description:
        'All SHOT trophies: for cases, Upgrade, Contracts, Rush Mid, Case Battles and activity. See how to earn each one, track your progress and check the reward.',
      h1: 'SHOT trophies',
    },
    uz: {
      title: 'SHOT kuboklari — vazifalar va mukofotlar',
      description:
        'SHOTʼning barcha kuboklari: keyslar, Upgrade, Kontraktlar, Rush Mid, Keys Janglar va faollik uchun. Har birini olish shartlari, progress va mukofotni koʻr.',
      h1: 'SHOT kuboklari',
    },
    fa: {
      title: 'جام‌های SHOT — چالش‌ها و جایزه‌ها',
      description:
        'همه جام‌های SHOT: برای کیس‌ها، ارتقا، قراردادها، Rush Mid، نبرد کیس و فعالیت. شرط گرفتن هرکدام، پیشرفتت و جایزه هر جام را ببین.',
      h1: 'جام‌های SHOT',
    },
    pt: {
      title: 'Troféus do SHOT — desafios e recompensas',
      description:
        'Todos os troféus do SHOT: por caixas, Upgrade, Contratos, Rush Mid, Batalhas de caixas e atividade. Veja como conquistar cada um, seu progresso e a recompensa.',
      h1: 'Troféus do SHOT',
    },
    tr: {
      title: 'SHOT kupaları — görevler ve ödüller',
      description:
        "SHOT'un tüm kupaları: kasalar, Upgrade, Kontratlar, Rush Mid, Kasa savaşları ve etkinlik için. Her birinin koşullarını, ilerlemeni ve ödülünü gör.",
      h1: 'SHOT kupaları',
    },
  },
  '/help/level': {
    ru: {
      title: 'Уровни и XP на SHOT — как прокачаться',
      description:
        'Как работают уровни SHOT: за что начисляется XP, сколько нужно до следующего уровня и какие бонусы открываются на ключевых уровнях.',
      h1: 'Уровни и XP на SHOT',
    },
    en: {
      title: 'SHOT levels and XP — how to level up',
      description:
        'How SHOT levels work: what earns you XP, how much you need for the next level and which bonuses unlock at the key levels along the way.',
      h1: 'SHOT levels and XP',
    },
    uz: {
      title: 'SHOTʼda darajalar va XP — qanday oshirish',
      description:
        'SHOT darajalari qanday ishlaydi: XP nima uchun beriladi, keyingi darajagacha qancha kerak va asosiy darajalarda qanday bonuslar ochiladi.',
      h1: 'SHOTʼda darajalar va XP',
    },
    fa: {
      title: 'سطح‌ها و XP در SHOT — چطور سطحت را بالا ببری',
      description:
        'سطح‌های SHOT چطور کار می‌کنند: برای چه کارهایی XP می‌گیری، تا سطح بعد چقدر لازم است و در سطح‌های کلیدی چه بونوس‌هایی باز می‌شود.',
      h1: 'سطح‌ها و XP در SHOT',
    },
    pt: {
      title: 'Níveis e XP no SHOT — como subir de nível',
      description:
        'Como funcionam os níveis do SHOT: o que dá XP, quanto falta para o próximo nível e quais bônus são liberados nos níveis principais.',
      h1: 'Níveis e XP no SHOT',
    },
    tr: {
      title: "SHOT'ta seviyeler ve XP — nasıl yükselirsin",
      description:
        "SHOT seviyeleri nasıl çalışır: XP'yi neyle kazanırsın, bir sonraki seviyeye ne kadar kaldı ve önemli seviyelerde hangi bonuslar açılır.",
      h1: "SHOT'ta seviyeler ve XP",
    },
  },
  '/help/recruiter': {
    ru: {
      title: 'Программа для блогеров SHOT',
      description:
        'Снимай обзоры SHOT для Instagram и TikTok и получай вознаграждение за просмотры. Рассказываем, что показать в видео, как подать заявку и как проходят выплаты.',
      h1: 'Программа для блогеров SHOT',
    },
    en: {
      title: 'SHOT Blogger Program',
      description:
        'Make SHOT review videos for Instagram and TikTok and get rewarded for views. Here is what to show in the video, how to apply and how payouts work.',
      h1: 'SHOT Blogger Program',
    },
    uz: {
      title: 'SHOT blogerlar dasturi',
      description:
        'Instagram va TikTok uchun SHOT haqida obzor suratga ol va koʻrishlar uchun mukofot ol. Videoda nimani koʻrsatish, qanday ariza berish va toʻlovlar haqida aytamiz.',
      h1: 'SHOT blogerlar dasturi',
    },
    fa: {
      title: 'برنامه بلاگرهای SHOT',
      description:
        'برای اینستاگرام و تیک‌تاک ویدیوی معرفی SHOT بساز و برای بازدیدها پاداش بگیر. می‌گوییم در ویدیو چه نشان بدهی، چطور درخواست بدهی و پرداخت‌ها چطور انجام می‌شود.',
      h1: 'برنامه بلاگرهای SHOT',
    },
    pt: {
      title: 'Programa para criadores do SHOT',
      description:
        'Grave vídeos sobre o SHOT para Instagram e TikTok e receba recompensa pelas visualizações. Veja o que mostrar no vídeo, como se inscrever e como são os pagamentos.',
      h1: 'Programa para criadores do SHOT',
    },
    tr: {
      title: 'SHOT içerik üreticisi programı',
      description:
        'Instagram ve TikTok için SHOT tanıtım videoları çek, izlenmeler için ödül al. Videoda ne göstereceğini, nasıl başvuracağını ve ödemelerin nasıl yapıldığını anlatıyoruz.',
      h1: 'SHOT içerik üreticisi programı',
    },
  },
  '/how-it-works': {
    ru: {
      title: 'Как работает SHOT — баланс, кейсы и предметы',
      description:
        'Как устроен SHOT: пополняешь баланс, открываешь кейсы и получаешь цифровые предметы. Их можно оставить, продать за баланс или вывести в Steam, если это доступно.',
      h1: 'Как работает SHOT',
    },
    en: {
      title: 'How SHOT works — balance, cases and items',
      description:
        'How SHOT works: top up your balance, open cases and get digital items. Keep them, sell them for balance or withdraw them to Steam when that option is available.',
      h1: 'How SHOT works',
    },
    uz: {
      title: 'SHOT qanday ishlaydi — balans, keyslar va predmetlar',
      description:
        'SHOT qanday ishlaydi: balansni toʻldirasan, keyslarni ochasan va raqamli predmetlar olasan. Ularni saqlash, balansga sotish yoki imkon boʻlsa Steamʼga chiqarish mumkin.',
      h1: 'SHOT qanday ishlaydi',
    },
    fa: {
      title: 'SHOT چطور کار می‌کند — موجودی، کیس‌ها و آیتم‌ها',
      description:
        'SHOT چطور کار می‌کند: موجودی را شارژ می‌کنی، کیس باز می‌کنی و آیتم دیجیتال می‌گیری. می‌توانی نگهش داری، با موجودی بفروشی یا اگر ممکن بود به Steam برداشت کنی.',
      h1: 'SHOT چطور کار می‌کند',
    },
    pt: {
      title: 'Como o SHOT funciona — saldo, caixas e itens',
      description:
        'Como o SHOT funciona: você recarrega o saldo, abre caixas e recebe itens digitais. Pode guardá-los, vendê-los por saldo ou retirá-los para a Steam quando disponível.',
      h1: 'Como o SHOT funciona',
    },
    tr: {
      title: 'SHOT nasıl çalışır — bakiye, kasalar ve eşyalar',
      description:
        "SHOT nasıl çalışır: bakiyeni yüklersin, kasa açarsın ve dijital eşyalar alırsın. Onları saklayabilir, bakiye karşılığında satabilir ya da mümkünse Steam'e çekebilirsin.",
      h1: 'SHOT nasıl çalışır',
    },
  },
  '/support': {
    ru: {
      title: 'Поддержка SHOT — как с нами связаться',
      description:
        'Напиши в поддержку SHOT на почту или в Telegram, если что-то пошло не так с балансом, кейсом или выводом предмета. Здесь же часы работы и сроки ответа.',
      h1: 'Поддержка SHOT',
    },
    en: {
      title: 'SHOT support — how to reach us',
      description:
        'Contact SHOT support by email or Telegram if something went wrong with your balance, a case or an item withdrawal. Working hours and response times are here too.',
      h1: 'SHOT support',
    },
    uz: {
      title: 'SHOT qoʻllab-quvvatlash — biz bilan aloqa',
      description:
        'Balans, keys yoki predmetni chiqarishda muammo boʻlsa, SHOT qoʻllab-quvvatlash xizmatiga pochta yoki Telegram orqali yoz. Ish vaqti va javob muddati ham shu yerda.',
      h1: 'SHOT qoʻllab-quvvatlash',
    },
    fa: {
      title: 'پشتیبانی SHOT — راه‌های تماس',
      description:
        'اگر در موجودی، کیس یا برداشت آیتم مشکلی پیش آمد، از طریق ایمیل یا تلگرام به پشتیبانی SHOT پیام بده. ساعت کاری و زمان پاسخ هم اینجاست.',
      h1: 'پشتیبانی SHOT',
    },
    pt: {
      title: 'Suporte do SHOT — como falar com a gente',
      description:
        'Fale com o suporte do SHOT por e-mail ou Telegram se algo der errado com o seu saldo, uma caixa ou a retirada de um item. Veja também o horário e o prazo de resposta.',
      h1: 'Suporte do SHOT',
    },
    tr: {
      title: 'SHOT destek — bize nasıl ulaşırsın',
      description:
        "Bakiye, kasa ya da eşya çekme işleminde bir sorun olursa SHOT desteğine e-posta veya Telegram'dan yaz. Çalışma saatleri ve yanıt süreleri de burada.",
      h1: 'SHOT destek',
    },
  },
  '/contacts': {
    ru: {
      title: 'Контакты SHOT — реквизиты и связь',
      description:
        'Реквизиты и контакты SHOT: ИНН, юридический адрес, телефон и электронная почта. Вопросы по аккаунту, балансу и предметам быстрее решит поддержка.',
      h1: 'Контакты SHOT',
    },
    en: {
      title: 'SHOT contacts and company details',
      description:
        'SHOT contacts and company details: tax ID, legal address, phone and email. For questions about your account, balance or items, support will answer faster.',
      h1: 'SHOT contacts',
    },
    uz: {
      title: 'SHOT kontaktlari va rekvizitlari',
      description:
        'SHOT rekvizitlari: STIR, yuridik manzil, telefon va elektron pochta. Akkaunt, balans yoki predmetlar boʻyicha savollarga qoʻllab-quvvatlash tezroq javob beradi.',
      h1: 'SHOT kontaktlari',
    },
    fa: {
      title: 'تماس با SHOT و مشخصات کسب‌وکار',
      description:
        'اطلاعات تماس و مشخصات SHOT: شناسه مالیاتی، نشانی حقوقی، تلفن و ایمیل. برای سؤال درباره حساب، موجودی یا آیتم‌ها، پشتیبانی سریع‌تر پاسخ می‌دهد.',
      h1: 'تماس با SHOT',
    },
    pt: {
      title: 'Contatos e dados do SHOT',
      description:
        'Contatos e dados do SHOT: ID fiscal, endereço legal, telefone e e-mail. Para dúvidas sobre conta, saldo ou itens, o suporte responde mais rápido.',
      h1: 'Contatos do SHOT',
    },
    tr: {
      title: 'SHOT iletişim ve şirket bilgileri',
      description:
        'SHOT iletişim ve şirket bilgileri: vergi numarası, yasal adres, telefon ve e-posta. Hesap, bakiye ya da eşyalarla ilgili sorularda destek daha hızlı yanıt verir.',
      h1: 'SHOT iletişim',
    },
  },
  '/refund-terms': {
    ru: {
      title: 'Условия возврата средств — SHOT',
      description:
        'Условия возврата SHOT: когда можно вернуть деньги за пополнение баланса, а когда нет, как отправить запрос в поддержку и сколько длится рассмотрение.',
      h1: 'Условия возврата средств',
    },
    en: {
      title: 'Refund terms — SHOT',
      description:
        'SHOT refund terms: when a balance top-up can be refunded and when it cannot, how to send a request to support and how long the review takes.',
      h1: 'Refund terms',
    },
    uz: {
      title: 'Qaytarish shartlari — SHOT',
      description:
        'SHOT qaytarish shartlari: balansni toʻldirish uchun pul qachon qaytariladi va qachon qaytarilmaydi, soʻrovni qanday yuborish va koʻrib chiqish qancha davom etishi.',
      h1: 'Qaytarish shartlari',
    },
    fa: {
      title: 'شرایط بازگشت وجه — SHOT',
      description:
        'شرایط بازگشت وجه در SHOT: چه زمانی مبلغ شارژ موجودی برگردانده می‌شود و چه زمانی نه، چطور درخواست بدهی و بررسی آن چقدر طول می‌کشد.',
      h1: 'شرایط بازگشت وجه',
    },
    pt: {
      title: 'Condições de reembolso — SHOT',
      description:
        'Condições de reembolso do SHOT: quando uma recarga de saldo pode ser devolvida e quando não, como enviar o pedido ao suporte e quanto tempo leva a análise.',
      h1: 'Condições de reembolso',
    },
    tr: {
      title: 'İade koşulları — SHOT',
      description:
        'SHOT iade koşulları: bakiye yüklemesi hangi durumlarda iade edilir, hangilerinde edilmez, talep nasıl gönderilir ve inceleme ne kadar sürer.',
      h1: 'İade koşulları',
    },
  },
  '/digital-content': {
    ru: {
      title: 'Получение цифрового контента — SHOT',
      description:
        'Как SHOT выдаёт цифровой контент: предметы приходят внутри платформы, часть из них можно вывести на свой аккаунт Steam, передача идёт автоматически.',
      h1: 'Получение цифрового контента',
    },
    en: {
      title: 'Receiving digital content — SHOT',
      description:
        'How SHOT delivers digital content: items arrive inside the platform, some of them can be withdrawn to your own Steam account, and transfers run automatically.',
      h1: 'Receiving digital content',
    },
    uz: {
      title: 'Raqamli kontent olish — SHOT',
      description:
        'SHOT raqamli kontentni qanday beradi: predmetlar platforma ichida beriladi, ayrimlarini oʻz Steam akkauntingga chiqarish mumkin, oʻtkazma avtomatik amalga oshadi.',
      h1: 'Raqamli kontent olish',
    },
    fa: {
      title: 'دریافت محتوای دیجیتال — SHOT',
      description:
        'SHOT محتوای دیجیتال را چطور تحویل می‌دهد: آیتم‌ها داخل پلتفرم داده می‌شوند، بعضی را می‌توانی به حساب Steam خودت برداشت کنی و انتقال خودکار است.',
      h1: 'دریافت محتوای دیجیتال',
    },
    pt: {
      title: 'Recebimento de conteúdo digital — SHOT',
      description:
        'Como o SHOT entrega conteúdo digital: os itens chegam dentro da plataforma, alguns podem ser retirados para a sua conta Steam e a transferência é automática.',
      h1: 'Recebimento de conteúdo digital',
    },
    tr: {
      title: 'Dijital içerik alma — SHOT',
      description:
        'SHOT dijital içeriği nasıl teslim eder: eşyalar platform içinde verilir, bazılarını kendi Steam hesabına çekebilirsin ve aktarım otomatik yapılır.',
      h1: 'Dijital içerik alma',
    },
  },
};

const PATTERNS = Object.keys(ROUTE_SEO);

const isParam = (segment: string) => segment.startsWith('[') && segment.endsWith(']');

// WHY: параметр в шаблоне — только id, иначе /case-battles/create и /case-battles/history получили бы тексты баттла
const matchesPattern = (pattern: string, path: string): boolean => {
  const expected = pattern.split('/');
  const actual = path.split('/');
  return (
    expected.length === actual.length &&
    expected.every((segment, i) => (isParam(segment) ? isValidUuid(actual[i]) : segment === actual[i]))
  );
};

export function findRouteSeo(path: string): RouteSeo | undefined {
  const pattern = PATTERNS.find((candidate) => matchesPattern(candidate, path));
  return pattern ? ROUTE_SEO[pattern] : undefined;
}

export const STATIC_SEO_PATHS: readonly string[] = PATTERNS.filter((pattern) => !pattern.split('/').some(isParam));
